<template>
    <div class="wrapper-excel">
        <div class="title top">数据操作</div>
        <div class="class-function">
            <div class="title">工作表</div>
            <el-input
                    style="font-size: 12px"
                    size="small"
                    v-model="inputSheet"
                    placeholder="输入表单名称，如 Sheet1"
                    class="input"
            >
            </el-input>
            <div class="class-error">{{error1}}</div>
        </div>
        <div class="class-function">
            <div class="title">数据区域</div>
            <el-input
                    style="font-size: 12px"
                    rows="2"
                    size="small"
                    v-model="inputCellRange"
                    placeholder="输入单元格名称，如 A1，或区域 A1:B2 批量填充时不同数据区域用‘;’隔开"
                    type="textarea"
            >
            </el-input>
            <div class="class-error">{{error2}}</div>
        </div>
        <div class="class-function">
            <div class="title">填写数据</div>
            <el-input
                    type="textarea"
                    rows="5"
                    style="font-size: 12px"
                    v-model="inputText"
                    placeholder="请输入需要替换或插入的数据。如：A1:畅写Office；A2:点亮新办公，填写的数据用 ';' 隔开，批量填充时填写的数据用'，'隔开 不同区域的数据用';'隔开"
                    class="input"
            ></el-input>
            <div class="class-button">
                <el-button type="primary" size="mini" :disabled="canReplace"
                           @click="actionSetCellContent" class="single-button"
                >内容替换</el-button>
                <el-button type="primary" size="mini" :disabled="canInsert"
                           @click="actionSetCellContent" class="single-button"
                >插入内容</el-button>
                 <el-button type="primary" size="mini" :disabled="canInsert"
                            @click="BulkFillContent" class="single-button"
                >批量填充</el-button>
            </div>
        </div>
        <br>
        <div class="class-button">
            <el-button type="primary" size="small" class="single-button"
                       @click="actionGetCellContent">数据提取
            </el-button>
            <el-button type="primary" size="small" class="single-button"
                       @click="dialogFormVisible2=true">设置数据项
            </el-button>
            <el-button type="primary" size="small" class="single-button"
                       @click="dialogFormVisible=true">删除数据项
            </el-button>
            <div class="class-display">{{selectedText}}</div>
            <div class="class-error">{{error3}}</div>
        </div>
        <div class="class-button">
            <el-button type="primary" size="small" class="single-button"
                       @click="actionEmpCellContent">清空Sheet页
            </el-button>
        </div>

        <div class="class-button">
            <div class="title">数据只读设置</div>
            <div class="class-button">
                <el-button type="primary" size="mini"
                           @click="actionSetProtected('cellrange', true)">设置单元格保护
                </el-button>
                <el-button type="primary" size="mini"
                           @click="actionSetProtected('sheet', true)">设置工作表保护
                </el-button>
            </div>
            <div class="class-button">
                <el-button type="primary" size="mini"
                           @click="actionSetProtected('cellrange', false)">取消单元格保护
                </el-button>
                <el-button type="primary" size="mini"
                           @click="actionSetProtected('sheet', false)">取消工作表保护
                </el-button>
            </div>
        </div>
        <div class="class-coauther">
            <div class="flex">
                <div class="">协作者权限配置</div>
                <el-radio-group v-model="partauthMode" class="class-radio">
                    <el-radio class="bottom-radio" :label="'view'">只读</el-radio>
                    <el-radio class="bottom-radio" :label="'edit'">编辑</el-radio>
                    <el-radio class="bottom-radio" :label="'hide'">隐藏</el-radio>
                </el-radio-group>
            </div>
            <el-button type="primary" size="mini" class="bottom-button"
                       @click="actionDistPartAuth"
            >应用</el-button>
        </div>
        <!-- 设置批量填充弹出框 -->
        <!-- <el-dialog
                :visible.sync="dialogFormVisible"
                :close-on-click-modal="false"
                v-dialogDrag:{dialogDrag}="dialog.dialogDrag"
                v-dialogChange:{dialogChange}="dialog.dialogChange"
                width="600px"
        >
            <div class="title">请输入需要批量填充的工作表</div>
            <el-input 
                    style="font-size: 12px"
                    size="small"
                    v-model="inputSheets"
                    placeholder="请输入输入表单名称，如 Sheet1 或 Sheet1; Sheet2,填写的表单用 '；' 隔开"
                    class="input"
            >
            </el-input>
            <div class="title">请输入需要批量填充的数据区域</div>
            <el-input 
                    style="font-size: 12px"
                    size="small"
                    v-model="inputCellRanges"
                    placeholder="输入单元格名称，如 A1，或区域 A1:B2，或A1; A2:B2,填写的单元格用 '；' 隔开"
                    class="input"
            >
            </el-input>
            <div class="title">请填写批量填充的数据</div>
            <el-input 
                    type="textarea"
                    rows="5"
                    style="font-size: 12px"
                    v-model="inputTexts"
                    placeholder="输入单元格名称，如 A1，或区域 A1:B2，或A1; A2:B2,填写的单元格用 '；' 隔开"
                    class="input"
            >
            </el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false" size="small" class="dialog-button">取 消</el-button>
                <el-button type="primary"
                           @click="BulkFillContent"
                           size="small"
                           class="dialog-button"
                           >确 定</el-button>
            </div>
        </el-dialog> -->
        <!-- 设置数据项弹出框 -->
        <el-dialog
                :visible.sync="dialogFormVisible2"
                :close-on-click-modal="false"
                v-dialogDrag:{dialogDrag}="dialog.dialogDrag"
                v-dialogChange:{dialogChange}="dialog.dialogChange"
                width="600px"
        >
            <div class="title">请输入设置数据项ID</div>
            <el-input 
                    style="font-size: 12px"
                    size="small"
                    v-model="dataID"
                    placeholder="请输入设置数据项ID"
                    class="input"
            >
            </el-input>
            <div class="title">请输入设置数据项名称</div>
            <el-input 
                    style="font-size: 12px"
                    size="small"
                    v-model="dataName"
                    placeholder="请输入设置数据项名称"
                    class="input"
            >
            </el-input>
            <!-- <div class="title">请输入数据项位置</div>
            <el-input 
                    type="textarea"
                    rows="5"
                    style="font-size: 12px"
                    v-model="dataPos"
                    placeholder="请输入数据项位置(格式如A1或者A1:B1)"
                    class="input"
            >
            </el-input> -->
            <div class="title">请输入设置数据项颜色（选填）</div>
            <el-input 
                    type="textarea"
                    rows="5"
                    style="font-size: 12px"
                    v-model="dataColor"
                    placeholder="请输入设置数据项颜色（选填,默认为#7CB7F2）"
                    class="input"
            >
            </el-input>
            <div class="title">请输入设置数据项自定义属性（选填）</div>
            <el-input 
                    type="textarea"
                    rows="5"
                    style="font-size: 12px"
                    v-model="dataCustom"
                    placeholder="请输入设置数据项自定义属性（选填）"
                    class="input"
            >
            </el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible2 = false" size="small" class="dialog-button">取 消</el-button>
                <el-button type="primary"
                           @click="actionSetDataContent"
                           size="small"
                           class="dialog-button"
                           >确 定</el-button>
            </div>
        </el-dialog>
        <!-- 删除数据项弹出框 -->
        <el-dialog
                :visible.sync="dialogFormVisible"
                :close-on-click-modal="false"
                v-dialogDrag:{dialogDrag}="dialog.dialogDrag"
                v-dialogChange:{dialogChange}="dialog.dialogChange"
                width="600px"
        >
            <div class="title">请输入删除数据项ID</div>
            <el-input 
                    style="font-size: 12px"
                    size="small"
                    v-model="delDataID"
                    placeholder="请输入删除数据项ID"
                    class="input"
            >
            </el-input>
            <div class="title">请输入删除数据项名称</div>
            <el-input 
                    style="font-size: 12px"
                    size="small"
                    v-model="delDataName"
                    placeholder="请输入删除数据项名称"
                    class="input"
            >
            </el-input>
            <!-- <div class="title">请输入数据项位置</div>
            <el-input 
                    type="textarea"
                    rows="5"
                    style="font-size: 12px"
                    v-model="delDataPos"
                    placeholder="请输入数据项位置(格式如A1)"
                    class="input"
            >
            </el-input> -->
            <div class="title">请输入删除数据项颜色（选填）</div>
            <el-input 
                    type="textarea"
                    rows="5"
                    style="font-size: 12px"
                    v-model="delDataColor"
                    placeholder="请输入删除数据项颜色（选填）"
                    class="input"
            >
            </el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false" size="small" class="dialog-button">取 消</el-button>
                <el-button type="primary"
                           @click="actionDelDataContent"
                           size="small"
                           class="dialog-button"
                           >确 定</el-button>
            </div>
        </el-dialog>

    </div>
        
</template>

<script>
    export default {
        name: "excelBar",
        props: ['docEditor', 'config', 'extractedCellContent', 'extractedCellContentAll'],
        data: function () {
            return {
                canReplace: false,
                canInsert: false,
                error1: '',
                error2: '',
                error3: '',
                inputSheet: '',
                inputCellRange: '',
                inputText: '',
                selectedText: '',
                inputSheets: '',
                inputCellRanges: '',
                inputTexts: '',
                dataID:'',
                dataName:'',
                dataPos:'',
                dataColor:'',
                dataCustom:'',
                delDataID:'',
                delDataName:'',
                delDataPos:'',
                delDataColor:'',
                dialogFormVisible:false,
                dialogFormVisible2:false,
                dialog: {                   // dialog显示隐藏
                    dialogDrag: true,       // 可拖拽
                    dialogChange: false,    // 可拉伸
                },
                partauthMode: 'view',
                placeholder: `请输入需要替换或插入的数据
如：A1：畅写Office；A2:点亮新办公
填写的数据用 ";" 隔开`,

                events:{
                    "onTypeDataChangeEvent": this.onTypeDataChangeEvent,
                    "onError": this.onError, 
                }
            }
        },
        created() {
        },
        methods: {
          actionSetCellContent: function () {
          this.cleanErrors()
          this.cleanErrors()
            if (!this.validateSheetName()) {
              return;
            }
          this.error1 = ''
          this.error2 = ''
          var input = this.inputCellRange;
            var expression;
            if (input.includes(':')) {
              if (this.inputText.lastIndexOf(";") > 0) {
                var arr = this.inputText.split(";");
                
                for (var i = 0; i < arr.length; i++) {
                  var CellArr = arr[i].split(":")
                  expression = {
                    object: CellArr[0],   //表示单元格名称如A1，B2等，必填项
                    type: "cellrange",  //表示操作行为的设置类型，固定值，必填项
                    value: CellArr[1],  //要设置的单元格内容，可以为“”（空值 ）， 必填项
                    sheet: this.inputSheet, //表单名称，若无该参数或为“”， 则为当前激活的表单，选填项
                  }
                  this.docEditor.setDocumentContent(expression);
                }
              } 
            }
          else {
              // 在表格中设置指定表单中的单元格内容
              expression = {
                object: this.inputCellRange,   //表示单元格名称如A1，B2等，必填项
                type: "cellrange",  //表示操作行为的设置类型，固定值，必填项
                value: this.inputText,  //要设置的单元格内容，可以为“”（空值 ）， 必填项
                sheet: this.inputSheet, //表单名称，若无该参数或为“”， 则为当前激活的表单，选填项
              }
              this.docEditor.setDocumentContent(expression);
            }
         
          },
          BulkFillContent: function () {
                this.cleanErrors()
                this.cleanErrors()
                    if (this.inputSheet === '') {
                    this.error1 = '请输入表单名称'
                    return false
                }
                this.error1 = ''
                this.error2 = ''
                var sheetInput = this.inputSheet;
                var input = this.inputCellRange;
                var arr = [];
                var dataArr = [];
                var dataArrs = [];
                var text = [];
                var expression;
                if (!sheetInput.includes(';')){ //工作表是一个
                    if (input.includes(";")) {//数据区域; 分开
                        arr = input.split(";");
                    }else{
                        arr = Array(input)
                    }
                    if(this.inputText.includes(';')){//,代表一个数据区域
                        var CellArrs = this.inputText.split(";")
                        for(var i=0;i < CellArrs.length; i++){
                            if(CellArrs[i].includes(',')){
                                text = CellArrs[i].split(",")
                                dataArrs.push(text)
                                text=[]
                            }else{
                                var text2 = CellArrs[i]
                                var arr2=[]
                                arr2.push(text2)
                                dataArrs.push(arr2)
                                arr2=[]

                            }
                            
                        }                   

                    }else{
                        CellArrs = this.inputText
                        if(CellArrs.includes(',')){
                                text = CellArrs.split(",")
                                dataArrs.push(text)
                                text=[]
                            }else{
                                var text2 = CellArrs
                                var arr2=[]
                                arr2.push(text2)
                                dataArrs.push(arr2)
                                arr2=[]

                            }

                    }
                    expression = {
                                    type:"cellrangeall",
                                    //表示操作行为的设置类型，固定值，必填项
                                    sheet:sheetInput,
                                    object:arr,
                                    value:dataArrs,
                                    createdSheet:true ,
                                    //若 sheet 参数指向的表单不存在，则创建该表单，选填项。
                                    clearExistSheet: false
                                    //对已存在的表单填充前是否清除所有单元格内容，选填项。
                                }
                                // this.docEditor.setDocumentContent(expression);
                    
                // }else {
                //     var arrSheet = sheetInput.split("; ");
                //     for(var i= 0; i < arrSheet.length; i++){
                //         expression = {
                //             type:"cellrangeall",
                //             //表示操作行为的设置类型，固定值，必填项
                //             sheet:arrSheet,
                //             //表单名称数组，数组类型， 必填项
                //             object:{'Sheet1': ['A10:B15', 'A20:C22', 'A25', 'C25'],
                //                     'Sheet2': ['A20:B25', 'A20:C22', 'A25', 'C25']
                //                     },
                //             //各表单对应的区域名称数组， 对象类型，必填项
                //             value:{'Sheet1': [
                //                 ['1',' ','3','4','5','7'],
                //                 ['11',' ','13','14','15','16'],
                //                 ['21'],
                //                 ['41']
                //                 ],
                //                 'Sheet2': [
                //                 ['1',' ','3','4','5','6'],
                //                 ['11',' ','13','14','15','16'],
                //                 ['21'],
                //                 ['41']
                //                 ]
                //             }
                //         }
                //     }
                    
                }
                this.docEditor.setDocumentContent(expression);
          },
          actionGetCellContent: function () {
                this.cleanErrors()
                this.cleanErrors()
                if (!this.validateSheetName()) {
                    return;
                }
                var input = this.inputCellRange;
                var expression;
                // 判断输入的单元格名称
                if (!input.includes(':')) {
                    // 在表格中提取指定表单中的单元格内容
                    expression = {
                        object: this.inputCellRange,    //表示单元格名称如A1，B2等，必填项
                        type: "cellrange",      //表示操作行为的设置类型，固定值，必填项
                        sheet: this.inputSheet,     //表单名称，若无该参数则为当前激活的表单，选填项
                    }
                    this.docEditor.getDocumentContent(expression);
                    setTimeout(() => {
                        // log("提取数据：", this.extractedCellContent)
                        if (!this.extractedCellContent['text']) {
                            this.error3 = '此单元格内容为空'
                            this.selectedText = ''
                        } else {
                            this.error3 = ''
                            this.selectedText = this.extractedCellContent['text']
                        }
                    }, 200)
                } else {
                    // 在表格中提取指定表单中的单元格内容
                    expression = {
                        object: this.inputCellRange,    //表示单元格名称如A1，B2等，必填项
                        type: "cellrangeall",      //表示操作行为的设置类型，固定值，必填项
                        sheet: this.inputSheet,     //表单名称，若无该参数则为当前激活的表单，选填项
                    }
                    this.docEditor.getDocumentContent(expression);
                    setTimeout(() => {
                        // log("this.extractedCellContentAll", this.extractedCellContentAll)
                        let content = JSON.parse(this.extractedCellContentAll['text'])
                        if (!content) {
                            this.error3 = '';
                            this.selectedText = ''
                            return;
                        }
                        var isEmpty = true;
                        Object.keys(content).forEach(function(x) {
                            if(content[x] !== null && content[x] !== "") {
                                isEmpty = false;
                            }
                        });
                        // log("isEmpty:", isEmpty)
                        if (isEmpty) {
                            this.error3 = '此单元格内容为空';
                            this.selectedText = ''
                        } else {
                            this.error3 = ''
                            this.selectedText = content
                        }
                    }, 200)
                }
            },
            actionEmpCellContent: function () {
                    var expression = {
                        type:"clearsheetcontent",
                        //表示操作行为的设置类型，固定值，必填项
                        sheet:this.inputSheet,
                        //表单名称，若无该参数则为当前激活的表单，选填项
                    }
                    this.docEditor.setDocumentContent(expression);
            },
            actionDelDataContent: function () {
                this.cleanErrors()
                this.cleanErrors()
                    if (!this.validateSheetName()) {
                    return;
                    }
                this.error1 = ''
                this.error2 = ''
                var data = {
                    id: this.delDataID,//数据项ID，必填项。
                    name: this.delDataName,//数据项名称，必填项。
                    pos: this.inputSheet + '!' + this.inputCellRange,//数据项位置，必填项。
                    color:this.delDataColor, //数据项的颜色，选填项。
                    };
                var expression;
                    expression = {
                        type:"removetypedata",
                        //表示操作行为的设置类型，固定值，必填项
                        value: [data]
                        //数据项列表，必填项
                    }
                    this.docEditor.setDocumentContent(expression);
                    this.dialogFormVisible=false
            },
            actionSetDataContent: function () {
                this.cleanErrors()
                this.cleanErrors()
                    if (!this.validateSheetName()) {
                    return;
                    }
                this.error1 = ''
                this.error2 = ''         
                var data = {
                        id: this.dataID,//数据项ID，必填项。
                        name: this.dataName,//数据项名称，必填项。
                        pos: this.inputSheet + '!' + this.inputCellRange,//数据项位置，必填项。由表单名称 + ‘!’+ 区域名称组成，区域可以是某个单元格，如A1，C3等，也可以是区域， 如A1：A1（其实就是A1单元格），A1:B5等。
                        color:this.dataColor,//数据项的颜色，3位或6位格式的十六进制颜色码，选填项。默认为#7CB7F2
                        custom1:this.dataCustom,

                    };
                var expression;
                    expression = {
                        type:"settypedata",
                        //表示操作行为的设置类型，固定值，必填项
                        value: [data]
                        //数据项列表，必填项
                    }
                    this.docEditor.setDocumentContent(expression);
                    this.dialogFormVisible2= false
            },
            actionSetProtected: function (type, protect) {
                var expression
                if (type === 'cellrange') {
                    // 在表格中设置指定表单中的单元格是否进行数据保护
                    expression = {
                        object: this.inputCellRange,     //表示单元格名称如A1，B2,也可以是单元格区域如A1:B2，必填项
                        type: "cellrange",       //表示操作行为的设置类型，固定值，必填项
                        protected: protect,        //true: 数据 保护，false: 数据可写， 必填项
                        sheet: this.inputSheet, //表单名称，若无该参数或为“”， 则为当前激活的表单，选填项
                    }
                    this.docEditor.setDocumentContent(expression);
                } else if (type === 'sheet') {
                    // 在表格中设置指定表单中的单元格是否进行数据保护
                    expression = {
                        object: this.inputSheet,    //表单名称，若无该参数或为“”， 则为当前激活的表单，选填项
                        type: "sheet",  //表示操作行为的设置类型，固定值，必填项
                        protected: protect,    //true: 数据 保护，false: 数据可写， 必填项
                    }
                    this.docEditor.setDocumentContent(expression);
                }
            },
            actionDistPartAuth: function () {
                this.cleanErrors()
                if (!this.validateSheetName()) {
                    return;
                }
                var routeData = this.$router.resolve({
                    path: "/partauth",
                    query: {
                        fileName: this.config.document.title,
                        userid: this.config.editorConfig.user.id,
                        name: this.config.editorConfig.user.name,
                        partId: this.inputSheet + '!' + this.inputCellRange,
                        partauthMode: this.partauthMode,
                    }
                });
                // log("routeData:", routeData)
                window.open(routeData.href, "_blank");

            },
            // 校验工作表名称
            validateSheetName: function() {
                let digits = '0123456789'
                let sheetName = this.inputSheet
                let cellsName = this.inputCellRange
                // 未输入
                if (sheetName === '') {
                    this.error1 = '请输入表单名称'
                    return false
                }
                if (cellsName === '') {
                    this.error2 = '请输入单元格名称'
                    return false
                }
                return true
            },
            cleanErrors: function() {
                this.error1 = ''
                this.error2 = ''
                this.error3 = ''
            }
        }
    }
</script>

<style scoped>
    .wrapper-excel {
        padding: 20px;
    }
    .title {
        font-size: 14px;
    }
    .top {
        margin-bottom: 20px;
    }
    .class-function {
        margin-top: 10px;
    }
    .input {
        margin-top: 8px;
    }
    .class-button {
        margin-top: 15px;
    }
    .single-button {
        padding: 7px 7px;
    }
    .class-coauther {
        margin-top: 10px;
        border-top: 1px solid #DBDBDB;
        padding-top: 20px;
    }
    .class-radio {
        width: 160px;
    }
    .flex {
        display: flex;
        justify-content: space-between;
    }
    .bottom-button {
        margin-left: 100px;
        margin-top: 20px;
    }
    .class-display {
        width: 225px;
        height: 100px;
        background: #FFFFFF;
        border: 1px solid #E0E0E0;
        border-radius: 4px;
        margin-top: 15px;
        line-height: 20px;
        overflow-y: auto;
        padding: 5px 15px;
    }
    .class-error{
        height: 20px;
        font-size: 12px;
        color: #F45858;
    }


    /deep/ .el-input__inner:focus {
        border-color:#27774E;
    }

    /deep/ .el-textarea__inner:focus {
        border-color:#27774E;
    }
    /deep/ .el-button--primary {
        background-color: #27774E;
        border-color: #27774E;
    }
    /deep/ .el-radio__label {
        font-size: 12px;
    }
    /deep/ .el-radio {
        margin-right: 3px
    }
    /deep/ .el-radio__input.is-checked .el-radio__inner {
        background-color: #27774E;
        border-color: #27774E;
        color: #27774E;
    }
    /deep/ .el-radio__input.is-checked+.el-radio__label {
        color: #27774E;
    }

</style>



// WEBPACK FOOTER //
// src/components/excelBar.vue